"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSteps = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("../hooks/react");

/**
 * Hook for gallery
 * @param {number} initialStep step index on which to start
 * @param {number} count total number of steps
 * @returns {object} `{ activeStep, goToPreviousStep, goToNextStep, disablePrevious, disableNext }`
 */
var useSteps = function useSteps(initialStep, count) {
  var _useState = (0, _react.useState)(initialStep),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      activeStep = _useState2[0],
      setActiveStep = _useState2[1];

  var goToPreviousStep = function goToPreviousStep() {
    return setActiveStep(activeStep - 1);
  };

  var goToNextStep = function goToNextStep() {
    return setActiveStep(activeStep + 1);
  };

  var disablePrevious = activeStep <= 0;
  var disableNext = activeStep >= count - 1;
  return {
    activeStep: activeStep,
    goToPreviousStep: goToPreviousStep,
    goToNextStep: goToNextStep,
    disablePrevious: disablePrevious,
    disableNext: disableNext
  };
};

exports.useSteps = useSteps;